import { Component, OnInit } from '@angular/core';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';

@Component({
  selector: 'app-recommendation-message',
  templateUrl: './recommendation-message.component.html',
  styleUrls: ['./recommendation-message.component.scss']
})
export class RecommendationMessageComponent implements OnInit {
  assistedBookingListUrl: string;
  bodyText: string;
  buttonText: string;
  constructor(
    private readonly ref: DynamicDialogRef,
    public readonly config: DynamicDialogConfig
    ){ }

  ngOnInit(){
    this.assistedBookingListUrl = this.config.data.assistedUrl;
    this.bodyText = this.config.data.bodyText;
    this.buttonText = 'OK';
  }

  cancelDialog(): void {
    this.ref.close();
  }
}
